/**
 * Enums aus `IWM.Seefracht.Shared` sowie die Anzeigenamen aus den
 * `[Display(Name = …)]`-Attributen der DLL.
 *
 * System.Text.Json serialisiert die Werte als Zahl — die numerischen Werte sind daher
 * Teil des JSON-Vertrags und dürfen nicht verändert werden.
 */

export enum EntityTypes {
  ChinaAppSysGroup = 0,
  ChinaAppSysUser = 1,
  ChinaAppSysView = 2,
  ChinaAppSysViewField = 3,
  ChinaAppSysGruppenkennzeichen = 4,
  Bestellposition = 10,
  Kommentar = 11,
  Container = 12,
  Rechnungszuordnung = 14,
  Rechnung = 15,
  Dokument = 16,
}

export enum ChinaAppSysUserBevorzugteSprache {
  De = 0,
  Chn = 1,
}

export enum ValidationStatusTypes {
  INVALID = 0,
  VALID = 1,
}

export enum KommentarTyp {
  Reply = 0,
  PrivateNote = 1,
  Logging = 2,
}

export enum LaufzeitSchritt {
  Vorlauf = 0,
  Transport = 1,
  Nachlauf = 2,
  Anlieferung = 3,
}

export enum RechnungArtAufteilung {
  Anteilig = 0,
  FesterBetrag = 1,
}

export enum Rechnungsart {
  Seefracht = 0,
  Nachlauf = 1,
  Zoll = 2,
  EinfuhrUst = 3,
  Lagergeld = 4,
  Demurrage = 5,
}

export const entityTypeDisplayNames: Record<EntityTypes, string> = {
  [EntityTypes.ChinaAppSysGroup]: 'Gruppe',
  [EntityTypes.ChinaAppSysUser]: 'User',
  [EntityTypes.ChinaAppSysView]: 'View',
  [EntityTypes.ChinaAppSysViewField]: 'Feld',
  [EntityTypes.ChinaAppSysGruppenkennzeichen]: 'Gruppenkennzeichen',
  [EntityTypes.Bestellposition]: 'Bestellposition',
  [EntityTypes.Kommentar]: 'Kommentar',
  [EntityTypes.Container]: 'Container',
  [EntityTypes.Rechnungszuordnung]: 'Rechnungszuordnung',
  [EntityTypes.Rechnung]: 'Rechnung',
  [EntityTypes.Dokument]: 'Dokument',
};

export const bevorzugteSpracheDisplayNames: Record<ChinaAppSysUserBevorzugteSprache, string> = {
  [ChinaAppSysUserBevorzugteSprache.De]: 'Deutsch',
  [ChinaAppSysUserBevorzugteSprache.Chn]: 'Chinesisch',
};

export const rechnungsartDisplayNames: Record<Rechnungsart, string> = {
  [Rechnungsart.Seefracht]: 'Seefracht',
  [Rechnungsart.Nachlauf]: 'Nachlauf',
  [Rechnungsart.Zoll]: 'Zoll',
  [Rechnungsart.EinfuhrUst]: 'EinfuhrUst',
  [Rechnungsart.Lagergeld]: 'Lagergeld',
  [Rechnungsart.Demurrage]: 'Demurrage',
};

export const rechnungArtAufteilungDisplayNames: Record<RechnungArtAufteilung, string> = {
  [RechnungArtAufteilung.Anteilig]: 'Anteilig',
  [RechnungArtAufteilung.FesterBetrag]: 'FesterBetrag',
};
